"use strict";

exports.__esModule = true;
exports.yTickFormatter = void 0;
var _d3Format = require("d3-format");
var yTickFormatter = exports.yTickFormatter = function yTickFormatter(value) {
  var formatDecimal = (0, _d3Format.format)(",.2f");
  var SI = (0, _d3Format.format)(".2s");
  if (value >= 100000) {
    return value % 1 === 0 ? SI(value).replace(".0", "") : SI(value);
  } else {
    return value % 1 ? formatDecimal(value) : value;
  }
};